webpackJsonp([82566842578201],{

/***/ 1342:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"AgedBucketInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"amountCents","type":{"kind":"SCALAR","name":"Int","ofType":null}},{"defaultValue":null,"description":null,"name":"enabled","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":null,"name":"percent","type":{"kind":"SCALAR","name":"Decimal","ofType":null}},{"defaultValue":null,"description":null,"name":"statementNote","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"type","type":{"kind":"ENUM","name":"BillingGroupFeeType","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-aged-bucket-input-a71e967576243591c776.js